// Per-panel error boundary: a crash in one panel never takes down the shell.

import { Component, type ReactNode } from 'react'

interface Props {
  name: string
  children: ReactNode
}

interface State {
  error: string | null
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(err: unknown): State {
    return { error: String(err) }
  }

  render() {
    if (this.state.error !== null) {
      return (
        <div className="panel-error" role="alert">
          <b>{this.props.name} hit an error</b>
          Your design is safe. Reload the panel to continue; if this repeats, undo the last
          change.
          <div style={{ marginTop: 8 }}>
            <button onClick={() => this.setState({ error: null })}>Reload panel</button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
